module.exports = __webpack_public_path__ + "static/media/usce-building.1812aa59.png";